// src/components/PolishAudioButton/PolishAudioButton.tsx
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import './PolishAudioButton.less';

interface PolishAudioButtonProps {
  playPolish: boolean;
  onToggle: () => void;
}

// Przełącznik zostawia menu opcji otwarte (`data-keep-menu-open`), żeby nowy stan było widać
export const PolishAudioButton: FC<PolishAudioButtonProps> = ({
  playPolish,
  onToggle,
}) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      className={`button-pl ${playPolish ? 'on' : ''}`}
      onClick={onToggle}
      aria-pressed={playPolish}
      data-keep-menu-open
    >
      <span className="pl-badge" aria-hidden="true">pl</span>
      <span>
        {t('games:polishNarrator.label')}
        {/* Widać jedno słowo, ale miejsce jest na dłuższe — menu nie zmienia szerokości */}
        <span className="pl-state">
          <span>{t('games:polishNarrator.on')}</span>
          <span>{t('games:polishNarrator.off')}</span>
        </span>
      </span>
    </button>
  );
};
